import React from "react";
import {Line, LineChart} from "recharts";
import {GROUP_PALETTE} from "../Statistics/format.js";

/** Kleine Verlaufslinie ohne Achsen/Tooltip - für die Mitarbeitertabelle
 * (letzte 14 Tage je Mitarbeiter, Feld "verlauf" aus /nutzung/daten/mitarbeiter). */
export default function NutzungSparkline({values, width = 96, height = 28}) {
    if (!Array.isArray(values) || values.length === 0) {
        return null;
    }
    const daten = values.map((wert, index) => ({index, wert}));
    return (
        <LineChart width={width} height={height} data={daten} margin={{top: 2, right: 2, left: 2, bottom: 2}}>
            <Line type="monotone" dataKey="wert" stroke={GROUP_PALETTE[0]} strokeWidth={1.5} dot={false} isAnimationActive={false} />
        </LineChart>
    );
}
